import { checkPermission } from '@/utils/directive/permission' // 权限判断函数

export default {
  inserted(el, binding, vnode) {
    const { name, value } = binding

    let permission = []

    if (name === 'withdraw') {
      permission = ['ROLE_AUTH_SETTLEMENT_WITHDRAW']
    }

    if (name === 'financials-setting') {
      permission = ['ROLE_AUTH_FINANCIALS_SETTING']
    }
    if (name === 'qr-stand') {
      permission = ['ROLE_AUTH_QRCODE_ADM']
    }

    if (name === 'permission') {
      if (value && value instanceof Array && value.length > 0) {
        permission = value
      } else {
        throw new Error(`need roles! Like v-permission="['admin','editor']"`)
      }
    }

    const hasPermission = checkPermission(permission)

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
